module.exports = __webpack_public_path__ + "img/Google-Button.af9034ee.svg";